import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const sidesBaseEndpoint = ENDPOINTS.SIDES;
const productBaseEndpoint = ENDPOINTS.PRODUCT;

// Category API
export const sidesApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["sides"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getSides: builder.query({
        query: (payload) => `${productBaseEndpoint}/${sidesBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "sides" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetSidesQuery,
} = sidesApi;
